import { DeviceInfo }   from "../../../shared-gen/Model/Devices/DeviceInfo";
import { getDefaultID } from "../../core";

export class DeviceInfoFun {

	static createNew(): DeviceInfo {
		return {
			ID: getDefaultID(),
			ProviderID: "",
			Name: "",
			CustomID: "",
			LocationID: "",
			TerminalID: ""
		}
	}

}
